import React from 'react'
import classNames from 'classnames'
import dayjs from 'dayjs'
import { NewsTimelines } from '../types'
import { splitArrayIntoGroups } from '../../Utils/common-utils'
import InStockL2Heading from '../../Pages/InStockDetailPageV2/InL2Heading'
import Widget from './Widget'
import Carousel from '@/stories/components/Common/Carousel/Carousel'

export default React.memo(function TimelineWidget({
  heading,
  timelines,
  colour,
  bgTertiary = false,
  minwidth,
  pod,
  image_url,
  date,
  bgColor = 'bg-brand-white ',
  isMobile,
  itemClassName,
}: NewsTimelines & {
  bgTertiary?: boolean
  minwidth?: string
  pod?: string
  bgColor?: string
  isMobile?: boolean | null
  heading?: string
  itemClassName?: string
}) {
  if (!heading) {
    return null
  }
  let data
  if (timelines?.length) {
    data = splitArrayIntoGroups(timelines, isMobile ? 1 : 3)
  }

  const displayDate = `Today's Timeline - ${dayjs(
    date ? date : Date.now(),
  ).format('DD MMMM')}`

  return (
    <div className={classNames('', bgColor)}>
      {heading && <InStockL2Heading heading={heading} />}
      <Carousel
        showArrows
        stopAutoPlay
        dots
        showDotsOnMobileOnly
        showArrowsOnDesktop
      >
        <ul className={classNames('mb-6 mt-4 flex gap-3', itemClassName)}>
          {data?.map((el, index) => {
            return (
              <Widget
                isH3={(pod === 'stocks' && index === 0) || pod !== 'stocks'}
                data={el}
                image={{ png: image_url }}
                title={displayDate}
                key={`${el.title}-${index}`}
                color={colour}
                bgTertiary={bgTertiary}
                minwidth={minwidth}
              />
            )
          })}
        </ul>
      </Carousel>
    </div>
  )
})
